import React from 'react';
import Sanitiser from '../global/sanitiser';

// Confirmed against the Add/Edit FindingManagement form: these fields use
// TinyMCE and must be displayed like the existing View Finding page.
export const RICH_TEXT_FIELDS = Object.freeze([
  'finding_ps_reference', 'finding_summary', 'finding_action'
]);
const richFields = new Set(RICH_TEXT_FIELDS);
const responseValues = value => {
  try {
    const x=typeof value==='string'?JSON.parse(value):value;
    return Array.isArray(x)?x:null;
  } catch (_) { return null; }
};

const RichContent = ({value}) => (
  <div className="max-w-full overflow-x-auto rounded border border-gray-200 bg-white p-2
    text-sm break-words" style={{overflowWrap:'anywhere'}}>
    <Sanitiser html={value || ''} />
  </div>
);

/**
 * Safely displays rich-text fields as formatted text and tables, not HTML
 * source. Sanitiser is the existing shared DOMPurify-backed View Finding
 * renderer. Never inject raw user-entered HTML directly into the DOM.
 */
export default function AvrComparisonFieldValue({fieldName,value}) {
  if (!value) return <span className="text-gray-500">(empty)</span>;
  if (richFields.has(fieldName)) return <RichContent value={value}/>;
  if (fieldName==='finding_responses') {
    const responses=responseValues(value);
    if (responses) return <div className="space-y-3">
      {responses.length===0 && <span className="text-gray-500">(no responses)</span>}
      {responses.map((entry,index)=>(
        <div className="rounded border border-gray-200 p-2" key={entry?.id || index}>
          <p className="mb-2 text-sm font-semibold">
            Response {index+1}{entry?.response_status ? ': '+entry.response_status : ''}
          </p>
          <RichContent value={String(entry?.response_note||'')}/>
        </div>
      ))}
    </div>;
  }
  return <pre className="whitespace-pre-wrap break-words font-sans text-sm"
    style={{overflowWrap:'anywhere'}}>{value}</pre>;
}
